import { render, staticRenderFns } from "./chevron-right.vue?vue&type=template&id=c0a78190&scoped=true&"
import script from "./chevron-right.vue?vue&type=script&lang=js&"
export * from "./chevron-right.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0a78190",
  null
  
)

export default component.exports